import React, { useEffect, useState } from "react";
import { create } from "zustand";
import DataListStore from "../../store/DataListStore";
import ListViewV2 from "../App/DataListV2";
import { UpdateStatusPesanan } from "services/datalist/datalist-api";
import { Button, Input, Modal, notification, Space } from "antd";

import { CloseCircleOutlined } from "@ant-design/icons";
import { ClickLoadingButton } from "components/buttons/ClickLoadingButton";
import { UpdateStatusKeepan } from "services/datalist/datalist-api";

const defaultDataStore = create(DataListStore);

const ListKeepan = () => {
  const [keepan, setKeepan] = useState({});
  const [placement, setPlacement] = useState("");
  const [requestBy, setRequestBy] = useState("");

  const [kirimOpen, setKirimOpen] = useState(false);
  const [simpanOpen, setSimpanOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  let user = localStorage.getItem("auth-id");
  const userObj = JSON.parse(user);

  useEffect(() => {}, []);

  return (
    <>
      <Modal
        title="Simpan Barang Keepan Customer"
        open={simpanOpen}
        onCancel={(e) => {
          setSimpanOpen(false);
          setPlacement("");
        }}
        cancelButtonProps={{
          hidden: true,
        }}
        okText="Simpan"
        okButtonProps={{
          loading: loading,
        }}
        onOk={async () => {
          setLoading(true);
          var data = {
            sesionId: keepan.SesionID,
            sequence: keepan.No,
            user: userObj.firstName,
            action: "SIMPAN",
            placement: placement,
          };

          const { affect } = await UpdateStatusKeepan(data);

          if (affect && affect > 0) {
            notification.success({
              message: "Update Status Keepan",
              description: "Barang Keepan Telah disimpan.",
            });
          } else {
            notification.error({
              message: "Update Status Keepan",
              description: "Status Keepan gagal diupdate. Coba lagi nanti",
            });
          }

          setSimpanOpen(false);
          setLoading(false);
        }}
      >
        <label>Nama Rak/Lantai Penyimpanan</label>
        <Input
          value={placement}
          onChange={(e) => setPlacement(e.target.value)}
        />
      </Modal>
      <Modal
        title="Pengiriman Barang Keepan"
        open={kirimOpen}
        onCancel={(e) => {
          setKirimOpen(false);
          setRequestBy("");
        }}
        okText="Kirim"
        cancelButtonProps={{
          hidden: true,
        }}
        onOk={async () => {
          setLoading(true);
          var data = {
            sesionId: keepan.SesionID,
            sequence: keepan.No,
            user: userObj.firstName,
            action: "KIRIM",
            requestBy: requestBy,
          };

          const { affect } = await UpdateStatusKeepan(data);

          if (affect && affect > 0) {
            notification.success({
              message: "Update Status Keepan",
              description: "Status Keepan berhasil di update",
            });
          } else {
            notification.error({
              message: "Update Status Keepan",
              description: "Status Keepan gagal diupdate. Coba lagi nanti",
            });
          }

          setKirimOpen(false);
          setLoading(false);
        }}
      >
        <label>Nama Admin yang Meminta</label>
        <Input
          value={requestBy}
          onChange={(e) => setRequestBy(e.target.value)}
        />
      </Modal>
      <ListViewV2
        viewId={"listkeepan"}
        store={defaultDataStore}
        customRowAction={(props) => (
          <Space style={{ display: "flex", justifyContent: "left" }}>
            <ClickLoadingButton
              danger
              onClick={async () => {
                if (window.confirm("Yakin ingin menghapus data keepan ini?")) {
                  var data = {
                    sesionId: props.data.SesionID,
                    sequence: props.data.No,
                    user: userObj.firstName,
                    action: "UNKEEP",
                  };

                  const { affect } = await UpdateStatusPesanan(data);

                  if (affect && affect > 0) {
                    notification.success({
                      message: "Update Status Pesanan",
                      description: "Status pesanan berhasil di update",
                    });
                  } else {
                    notification.error({
                      message: "Update Status Pesanan",
                      description:
                        "Status pesanan gagal diupdate. Coba lagi nanti",
                    });
                  }
                }
              }}
            >
              <Space>
                <CloseCircleOutlined />
              </Space>
            </ClickLoadingButton>
            <Button
              type="primary"
              disabled={props.data.SendFlag}
              onClick={() => {
                setKeepan(props.data);
                setSimpanOpen(true);
                setLoading(false);
              }}
            >
              Simpan
            </Button>
            <Button
              disabled={props.data.SendFlag}
              onClick={() => {
                setKeepan(props.data);
                setKirimOpen(true);
                setLoading(false);
              }}
            >
              Kirim
            </Button>
          </Space>
        )}
        hideEdit
      />
    </>
  );
};

export default ListKeepan;
